import { render, staticRenderFns } from "./ActivationTaskCustomDeliveryProvider.vue?vue&type=template&id=13e2674e&"
import script from "./ActivationTaskCustomDeliveryProvider.vue?vue&type=script&lang=js&"
export * from "./ActivationTaskCustomDeliveryProvider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports